import router from "@/router";
import { TRACK_IDS } from "@/views/QuizFlow/components/enums";

const defaultState = {
  questions: null,
  tracks: null,
  goal: null,
  additionalGoal: null
}

const state = () => ({
  questions: defaultState.questions,
  tracks: defaultState.tracks,
  goal: defaultState.goal,
  additionalGoal: defaultState.additionalGoal
})

const getters = {
  getTracksInfo: state => state.tracks,
  getAllContent: state => state.questions,
  getValidContent: state => state.questions.filter(item => state.additionalGoal ? item.id : item.id && !item.add_goal_required),
  getCurrentQuestion: state => state.questions?.find(item => item.id === (Number(router.currentRoute.value.params.survey) || 1)),
  getProgressList: state => state.questions?.filter(item => item.count_progress),
  getSeparatorIdx: state => {
    const separators = state.questions?.filter(item => item.count_progress).map((item, idx) => {if (item.separator) return idx;});
    const filteredSeparators = separators?.filter(item => item);

    return filteredSeparators.length ? filteredSeparators : [1, 2, 3]
  },
  getBaseGoal: state => state.goal,
  getAddGoal: state => state.additionalGoal,
  getIsWelnessTrack: () => TRACK_IDS[localStorage.getItem('trackName')] === 3
}

const mutations = {
  SET_QUESTIONS(state, payload) {
    state.questions = payload;
  },
  SET_TRACKS_INFO(state, payload) {
    state.tracks = payload
  },
  SET_GOAL_INFO(state, payload) {
    state.goal = payload
  },
  SET_ADDGOAL_INFO(state, payload) {
    state.additionalGoal = payload
  }
}

const actions = {
  setQuestions({commit, state}, payload) {
    commit('SET_QUESTIONS', payload)
  },
  setAddGoal({commit, state}, payload) {
    const trackName = localStorage.getItem('trackName');

    if (payload?.remove) {
      sessionStorage.removeItem('addGoal');
      commit('SET_ADDGOAL_INFO', null)
      return
    }

    if (payload?.setNew) {
      const goal = state.questions[0].goals.additional[trackName]
      sessionStorage.setItem('addGoal', goal);
      commit('SET_ADDGOAL_INFO', goal)
    } else {
      const addGoalExist = sessionStorage.getItem('addGoal');
      if (addGoalExist) commit('SET_ADDGOAL_INFO', addGoalExist)
    }
  },
  setBaseGoal({commit, state}, payload) {
    const trackName = localStorage.getItem('trackName');

    if (payload?.setNew) {
      const goal = state.questions[0].goals.base[trackName]
      sessionStorage.setItem('goal', goal);
      commit('SET_GOAL_INFO', goal)
    } else {
      const isGoalExist = sessionStorage.getItem('goal');
      if (isGoalExist) commit('SET_GOAL_INFO', isGoalExist)
    }
  },
  setTracksInfo({commit, dispatch}, { tracks }) {
    if (tracks) {
      commit('SET_TRACKS_INFO', tracks)
      dispatch('setBaseGoal')
      dispatch('setAddGoal')
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
